<template>
    <div>
        <img
                  @click="
                    openInNewTab(
                      'https://www.pescholar.com/insight/the-primary-physical-education-concept-curriculum/'
                    )
                  "
                  class="w-6/12 pl-2"
                  src="/static/images/pescholar.png"
                  alt=""
                />

                <div class="p-5">
                  <h5
                    class="mb-2 text-lg font-bold tracking-tight text-gray-700 dark:text-white"
                  >
                    Primary Concept Curriculum
                  </h5>

                  <div
                    class="mb-3 font-normal text-gray-700 dark:text-gray-400"
                  >
                    <p>
                      PE should be a positive and meaningful learning
                      environment within which every young person feels included
                      and valued. Yet, for so many, PE is doing the opposite. It
                      is a humiliating, alienating and a demotivating experience
                      that is turning many away from the life-long benefits of
                      physical activity and the joy of movement.
                    </p>
                    <p>
                      When reflecting upon the purpose of PE, especially in
                      relation to the aims of the National Curriculum we must
                      consider the ABC’s of being:
                    </p>
                    <ul>
                      <li>Active for sustained periods of time</li>
                      <li>Building positive relationships with PEPASS</li>
                      <li>
                        Competence in a range of activities and environments
                      </li>
                      <li>
                        and, we also have an opportunity to add a D by: <br />
                        Developing character, knowledge and understanding
                        through physical activity
                      </li>
                    </ul>

                    <p>
                      Therefore, the purpose of the Primary Concept Curriculum
                      is not to create resilient individuals, strong leaders or
                      effective communicators.
                    </p>
                  </div>

                  <div
                    @click="
                      openInNewTab(
                        'https://www.pescholar.com/insight/the-primary-physical-education-concept-curriculum/'
                      )
                    "
                    class="link focus:ring-4 cursor-pointer focus:outline-none focus:ring-blue-300"
                  >
                    Read more (external link)
                    <i
                      class="fas fa-caret-right ml-3 text-base text-action-blue"
                    ></i>
                  </div>
                  <br />

                  <div
                    @click="
                      openInNewTab('https://shop.primarypepassport.co.uk/')
                    "
                    class="link cursor-pointer text-green-600 focus:ring-4 focus:outline-none focus:ring-blue-300"
                  >
                    Purchase add on curriculum (external link)
                    <i
                      class="fas fa-caret-right ml-3 text-base text-action-blue"
                    ></i>
                  </div>
                </div>
    </div>
</template>
<script>
    export default{
        name: "Concept",

        methods: {

openInNewTab(url) {
  window.open(url, '_blank');
},
},
    }
</script>
<style scoped>

</style>